<template>
  <main>
    <LoginSignup title="Sign In" />
  </main>
</template>

<script>
import LoginSignup from "../components/LogInSignup/LoginSignup.vue";
export default {
  components: { LoginSignup },
};
</script>
